import "bootstrap-italia/dist/css/bootstrap-italia.min.css";
import "bootstrap-italia/dist/js/bootstrap-italia.bundle.min.js";

import "./App.css";

import Repo from "./Components/Utility/Repo";
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useCookies } from "react-cookie";
import Header from "./Components/Layout/Header";
import { MemoizedFooter } from "./Components/Layout/Footer";
import Body from "./Components/Layout/Body";

function App() {
  const [cookies, setCookie] = useCookies();

  const [user, setUser] = useState({});
  const [apiToken] = useState(cookies.api_token);
  const [localEnte] = useState(cookies.ente);
  const [countCarello, setCountCarello] = useState({});
  const [carello, setCarello] = useState({});
  const [defaultEntity, setDefaultEntity] = useState(
    cookies.user_profile ? cookies.user_profile.AreaCode : ""
  );

  useEffect(() => {
    if (apiToken) {
      Repo.getUserProfile(apiToken)
        .then((response) => {
          setUser(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  let interval;
  useEffect(() => {
    interval = setInterval(() => {
      localStorage.clear();
      window.location.href = "/home";
    }, 32400000);
  }, [interval]);

  const listaLinkUtente = [
    { testo: "Home", url: "/home" },
    { testo: "Domande Frequenti", url: "/faq" },
    { testo: "Serve Aiuto?", url: "/help" },
  ];

  const listaLink = [
    { testo: "Home", url: "/home" },
    { testo: "Domande Frequenti", url: "/faq" },
    { testo: "Serve Aiuto?", url: "/help" },
  ];

  return (
    <div className="App">
      <div className="headerCustom">
        <Header
          LastName={user.LastName}
          FirstName={user.FirstName}
          url="http://www.servizilocalispa.com/"
          Title="Servizi Locali Spa"
          linksUtente={listaLinkUtente}
          links={listaLink}
          linksEsterni={user.Apps}
          AreaName={!localEnte ? "" : localEnte.nomeComune}
          EnteName={!localEnte ? "" : localEnte.nomeEnte}
          conteggio={countCarello}
        />
      </div>

      <Router>
        <Routes>
          <Route path="/" element={<Body />}></Route>
        </Routes>
      </Router>

      <MemoizedFooter> </MemoizedFooter>
    </div>
    // <FlexWebchat></FlexWebchat>
  );
}

export default App;
